import { Form, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { DefaultRangePicker, TextAreaBox, styleVariables } from '@lib/common';
import { disabledDate, disabledTime } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var NOTE_MAX_LENGTH = 750;
var StyledForm = styled(Form).withConfig({
  displayName: "publish-score-formcomponent__StyledForm",
  componentId: "sc-1gq3soz-0"
})([".ant-form-item{margin-bottom:20px;}.ant-form-item-label > label{height:auto;color:", ";font-size:14px;font-weight:600;}.ant-picker{min-height:40px;}.ant-input-textarea,textarea.ant-input{border-radius:", ";}textarea.ant-input{height:104px;padding:7px 11px;line-height:22px;resize:none;overflow-y:auto;}@media (max-width:480px){.ant-picker-input > input{font-size:12px;}.ant-picker-range-separator{padding:0 4px;}}"], styleVariables.colors.grey100, styleVariables.borderRadius.medium);
var FieldLabel = styled.span.withConfig({
  displayName: "publish-score-formcomponent__FieldLabel",
  componentId: "sc-1gq3soz-1"
})(["display:inline-flex;align-items:center;gap:6px;"]);
var RequiredMark = styled.span.withConfig({
  displayName: "publish-score-formcomponent__RequiredMark",
  componentId: "sc-1gq3soz-2"
})(["color:", ";"], styleVariables.colors.colorErrorBase);
var OptionalLabel = styled.span.withConfig({
  displayName: "publish-score-formcomponent__OptionalLabel",
  componentId: "sc-1gq3soz-3"
})(["color:", ";font-size:12px;font-weight:400;"], styleVariables.colors.grey70);
var HelpIcon = styled(QuestionCircleOutlined).withConfig({
  displayName: "publish-score-formcomponent__HelpIcon",
  componentId: "sc-1gq3soz-4"
})(["color:", ";font-size:13px;cursor:help;&:focus-visible{outline:2px solid ", ";outline-offset:2px;border-radius:4px;}"], styleVariables.colors.grey70, styleVariables.colors.blue3);
export var PublishScoreForm = function PublishScoreForm(_ref) {
  var form = _ref.form,
      label = _ref.label,
      errorLabel = _ref.errorLabel,
      onFormValuesChange = _ref.onFormValuesChange;
  return /*#__PURE__*/_jsxs(StyledForm, {
    form: form,
    layout: "vertical",
    onValuesChange: onFormValuesChange,
    requiredMark: false,
    children: [/*#__PURE__*/_jsx(Form.Item, {
      label: /*#__PURE__*/_jsxs(FieldLabel, {
        children: [/*#__PURE__*/_jsx("span", {
          children: label.linkExpiredAt
        }), /*#__PURE__*/_jsx(RequiredMark, {
          "aria-hidden": "true",
          children: "*"
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: label.accessPeriodHint,
          trigger: ['hover', 'focus'],
          children: /*#__PURE__*/_jsx(HelpIcon, {
            tabIndex: 0,
            "aria-label": label.accessPeriodHint
          })
        })]
      }),
      name: "linkExpiredAt",
      rules: [{
        required: true,
        message: errorLabel.notEmptyLinkExpiredAt
      }],
      children: /*#__PURE__*/_jsx(DefaultRangePicker, {
        disabledDate: disabledDate,
        disabledTime: disabledTime,
        showTime: {
          format: 'HH:mm'
        },
        format: "DD/MM/YYYY - HH:mm",
        placeholder: [label.expireLinkStartTime, label.expireLinkEndTime]
      })
    }), /*#__PURE__*/_jsx(Form.Item, {
      label: /*#__PURE__*/_jsxs(FieldLabel, {
        children: [/*#__PURE__*/_jsx("span", {
          children: label.note
        }), /*#__PURE__*/_jsx(OptionalLabel, {
          children: label.optional
        })]
      }),
      name: "note",
      normalize: function normalize(value) {
        return value === null || value === void 0 ? void 0 : value.slice(0, NOTE_MAX_LENGTH);
      },
      rules: [{
        max: NOTE_MAX_LENGTH,
        message: errorLabel.noteMaximumLength
      }],
      children: /*#__PURE__*/_jsx(TextAreaBox, {
        placeholder: label.noteInputPlaceHolder,
        maxLength: NOTE_MAX_LENGTH,
        showCount: true,
        rows: 4,
        autoSize: false
      })
    })]
  });
};